import { breakpoints } from 'theme/MuiThemeProvider/breakpoints';
import { customTheme } from 'theme/MuiThemeProvider/theme';
import { SxPropsTypes } from 'theme/MuiThemeProvider/types';

export const styles: SxPropsTypes = {
  modalPaper: {
    minWidth: '560px',
    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      minWidth: 'inherit',
    },
  },
  saveButton: {
    minWidth: '80px',
    marginBottom: '16px',
  },
  input: {
    borderRadius: '8px',
    border: '1px solid var(--Black-10, #E8E8E8)',
    background: customTheme.custom.white,
    padding: '4px 6px',
    color: customTheme.custom.black.B50,
  },
  inputLabel: {
    color: customTheme.custom.gray.G400,
    fontSize: '14px',
    fontWeight: 600,
    marginBottom: '8px',
  },
  inTouch: {
    textAlign: 'center',
    minWidth: '520px',
    fontSize: '14px',
    fontWeight: 500,
  },
  contact: {
    color: customTheme.palette.primary.main,
    textDecoration: 'underline',
  },
  descriptionInput: {
    padding: '8px 12px',
  },
  minOrderContainer: {
    display: 'flex',
    gap: '8px',
    marginBottom: '16px',
  },
  numberInputWrapper: {
    flex: 1,
    ':hover': {
      backgroundColor: customTheme.custom.white,
    },

    input: {
      border: `1px solid ${customTheme.custom.black.B10}`,
      borderRadius: '25px',
      fontSize: '14px',
      color: customTheme.custom.black.B100,

      padding: '8px 12px',
      background: customTheme.custom.white,
    },
  },
};
